














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CheckInAudio extends Vue {
  @Prop(String) readonly name!: string;
  @Prop(String) readonly duration!: string;
  @Prop(Boolean) readonly dark!: boolean;

  @Emit() remove(): void {}
}
